import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './contact.css'
const AdminContact = () => {
  const [contacts, setContacts] = useState([]); // State to store contacts data
  const url = process.env.REACT_APP_BASE_URL;

    const [query, setQuery] = useState("");
  
function fetchContacts(){
   // Fetching data from the API
   axios.get(`${url}/api/contacts/all?query=${encodeURIComponent(query)}`) // Replace with your actual API endpoint
   .then(response => {
     console.log(response.data.data);
     setContacts(response.data.data); // Assuming the API returns the contacts data
   })
   .catch(error => {
     console.error('There was an error fetching the contact data:', error);
   });
}


  useEffect(() => {
    console.log(query);
    console.log(contacts)
  if(query.length===0 || query.length>2) fetchContacts();
   
  }, [query]); 

  return (
    <div className='contact-container'>
      <h1>Contact</h1>
      <div className="filters">
        <input
          type="text"
          placeholder="Search..."
          value={query}
          onChange={(e) => setQuery( e.target.value )}
        />
   </div>
   <table className="contact-table">
        <thead>
          <tr>
            <th>Sr.no</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone number</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact, index) => (
            <tr key={index}>
              <td>{index+1}</td>
              <td>{contact.name}</td>
              <td>{contact.email || 'N/A'}</td>
              <td>{contact.subject || 'N/A'}</td>
              <td>{contact.message || 'N/A'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminContact;